<template>
  <div id="cancel-appointment-view" tabindex="-1">
    <div v-if="!cancelAppointmentLoading" class="reschedule">
      <h2 id="cancelHeading">{{ $t('messages.cancel_title') }}</h2>
      <div v-if="cancelAppointment.success" class="d-inline-flex align-items-center">
        <img src="../assets/check-icon-black.svg" alt="checkmark" id="checkBlack" />
        <p id="cancelText">{{ $t('messages.appointment_canceled') }}</p>
      </div>
      <p v-if="!cancelAppointment.success" id="cancelText">{{ this.errorMessage }}</p>
      <div class="section-separator"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useBookingStore } from '../store'

export default {
  name: 'CancelConfirmed',
  components: {},
  data() {
    return {
      errorMessage: '',
    }
  },
  mounted() {
    this.errorMessage = this.errorMessages()
    document.getElementById('cancel-appointment-view').focus()
  },
  computed: {
    ...mapState(useBookingStore, ['cancelAppointment', 'cancelAppointmentLoading']),
  },
  methods: {
    errorMessages() {
      switch (this.cancelAppointment.error) {
        case 'Appointment already canceled':
          return this.$i18n.t('messages.cancel_appointment_error_already')
        case 'Appointment cancel expired':
          return this.$i18n.t('messages.cancel_appointment_error_expired')
        case 'Appointment cancel failed, try again later':
          return this.$i18n.t('messages.cancel_appointment_error_try_again')
        default:
          return this.$i18n.t('messages.cancel_appointment_error_failed')
      }
    },
  },
  watch: {},
}
</script>
